/**
 * API Debug Helper - helps troubleshoot API connection issues
 */

export const logApiConfig = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  console.log('=== API Configuration ===');
  console.log('API URL:', apiUrl);
  console.log('Environment:', process.env.NODE_ENV);
  console.log('Build time variables available:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')));
  console.log('========================');
};

export const handlePdfDownloadError = (error, examType) => {
  console.error(`PDF Download Error for ${examType}:`, error);
  
  if (!error.response) {
    // Network error
    console.error('Network error - could not reach server');
    return 'Network error - cannot reach server. Check your connection and server status.';
  }
  
  if (error.response.status === 401) {
    console.error('Authentication failed - token expired or invalid');
    return 'Session expired. Please login again.';
  }
  
  if (error.response.status === 400) {
    console.error('Bad request:', error.response.data);
    return error.response.data.message || 'Invalid form data';
  }
  
  if (error.response.status === 500) {
    console.error('Server error:', error.response.data);
    return error.response.data.message || 'Server error occurred';
  }
  
  if (error.response.status === 0) {
    console.error('Request cancelled or blocked (possible CORS issue)');
    return 'Request blocked - check browser console for CORS errors';
  }
  
  console.error('Unknown error:', error.response.status, error.response.statusText);
  return `Error: ${error.response.status} ${error.response.statusText}`;
};

export const testApiConnection = async () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  
  console.log('Testing API connection to:', apiUrl);
  
  try {
    const response = await fetch(`${apiUrl}/api/health`);
    const data = await response.json();
    
    if (response.ok) {
      console.log('✓ API connection successful:', data);
      return { success: true, data };
    } else {
      console.error('✗ API returned error status:', response.status);
      return { success: false, status: response.status };
    }
  } catch (error) {
    console.error('✗ API connection failed:', error.message);
    return { success: false, error: error.message };
  }
};
